export * from './tab.component'
export * from './tabs-view.component';


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/tabs/index.ts